"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _IconWrapper = _interopRequireDefault(require("./IconWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FoodServices = function FoodServices(_ref) {
  var viewBox = _ref.viewBox;
  return /*#__PURE__*/_react.default.createElement(_IconWrapper.default, {
    viewBox: viewBox
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "8.78125",
    y: "12.5",
    width: "11.0625",
    height: "11",
    fill: "#5DACB0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.6629 20.7855H20.4533L20.3391 22.7093C20.3099 23.1944 20.0964 23.65 19.7423 23.9828C19.3882 24.3157 18.9203 24.5006 18.4343 24.4997H9.95814C9.47216 24.5006 9.00423 24.3157 8.65013 23.9828C8.29603 23.65 8.08255 23.1944 8.05339 22.7093L7.36768 11.376H21.0248L20.8533 14.1188H23.2343C23.3411 14.1183 23.4468 14.1402 23.5446 14.1832C23.6424 14.2261 23.73 14.2892 23.8019 14.3682C23.8737 14.4472 23.9281 14.5405 23.9616 14.6419C23.9951 14.7433 24.0069 14.8506 23.9962 14.9569L23.4248 20.0997C23.4058 20.2883 23.3172 20.4631 23.1764 20.5899C23.0355 20.7167 22.8524 20.7864 22.6629 20.7855ZM8.98672 12.8807L9.57719 22.595C9.58208 22.6927 9.62437 22.7847 9.69529 22.8521C9.76621 22.9195 9.86032 22.957 9.95814 22.9569H18.4343C18.5321 22.957 18.6262 22.9195 18.6972 22.8521C18.7681 22.7847 18.8104 22.6927 18.8153 22.595L19.4057 12.8807H8.98672ZM20.7581 15.6236L20.5295 19.2426H21.9771L22.3771 15.6236H20.7581Z",
    fill: "#00438F"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.2379 5.5H14.7617V9.88093H13.2379V5.5Z",
    fill: "#00438F"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.7623 6.8335H12.2861V9.8811H10.7623V6.8335Z",
    fill: "#00438F"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.7145 6.8335H17.2383V9.8811H15.7145V6.8335Z",
    fill: "#00438F"
  }));
};

FoodServices.propTypes = {
  viewBox: _propTypes.PropTypes.string
};
FoodServices.defaultProps = {
  viewBox: '0 0 30 30'
};
var _default = FoodServices;
exports.default = _default;